module.exports = __webpack_public_path__ + "img/20_127.791265e0.png";